import { apolloClient } from '~/apollo-client';
import {
  Flex_GenerateIlDisclosureFormMutation,
  Flex_GenerateIlDisclosureFormMutationVariables,
} from '~/typings/graphql';
import { GENERATE_IL_DISCLOSURE_FORM } from './request-ipa-contract-generation.queries';

interface RequestIpaContractGenerationParams {
  utilityAccountId: number;
  redirectUri?: string;
}

export interface RequestIpaContractGenerationResponse {
  enqueued: boolean;
  utilityAccountId: number;
}

export const requestIpaContractGeneration = async (
  params: RequestIpaContractGenerationParams,
): Promise<RequestIpaContractGenerationResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_GenerateIlDisclosureFormMutation,
    Flex_GenerateIlDisclosureFormMutationVariables
  >({
    mutation: GENERATE_IL_DISCLOSURE_FORM,
    variables: {
      utilityAccountId: params.utilityAccountId,
      redirectUri: params.redirectUri || '',
    },
  });

  if (!data?.generateIlDisclosureForm) {
    throw new Error('Failed to generate IL disclosure form');
  }

  return {
    enqueued: data.generateIlDisclosureForm.enqueued,
    utilityAccountId: data.generateIlDisclosureForm.utilityAccountId,
  };
};
